import React from "react";
import ForestOwnerListItem from "../../components/forestOwner/ForestOwnerList/ForestOwnerListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const ForestOwnerListPage = ()  => {

    useTitle(t`List Forest Owner`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <ForestOwnerListItem showAdd={true} {...query} />
        </Box>
    )
}

export default ForestOwnerListPage;
